"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configDefaults = void 0;
var _nuiConfig = _interopRequireDefault(require("@concur/nui-config"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var configDefaults = exports.configDefaults = {
  nui: {
    session: {
      use_performance_degrading_session_logging: {
        value: true,
        useDefault: true
      }
    },
    log: {
      application: {
        useDefault: true,
        clientExposed: true,
        value: ''
      },
      // as defined in RMS
      roletype: {
        clientExposed: true,
        value: 'nuiex'
      },
      level: {
        useDefault: true,
        clientExposed: true,
        value: 'info'
      },
      verbose: {
        useDefault: true,
        clientExposed: true,
        value: true
      },
      useBrowserConsole: {
        useDefault: true,
        clientExposed: true,
        value: true
      },
      // The version of the application running.
      // This should be traceable back to the source control system
      version: {
        useDefault: true,
        clientExposed: true,
        value: ''
      }
    }
  }
};
var _default = exports.default = (0, _nuiConfig.default)(configDefaults);